import { useAuth } from '../../authentication/hooks/useAuth';

export function useHasRole(role: string | string[]): boolean {
  const auth = useAuth();

  const allowedRoles = Array.isArray(role) ? role : [role];

  return allowedRoles.includes(auth.user.role);
}
